import { IconDefinition } from '@ant-design/icons-angular';

export const HolderOutline: IconDefinition = {
    name: 'holder',
    theme: 'outline',
    icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z" /></svg>'
}